export enum ConsentStatusType {
  CREATED = "CREATED",
  REVOKED = "REVOKED",
  PAUSED = "PAUSED",
  ACTIVE = "ACTIVE",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export enum ConsentApprovalStatusType {
  PENDING = "PENDING",
}
